export default __webpack_public_path__ + "static/media/housing.98d7c9bf.svg";